import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';
import { RegExps } from '../resources/regexps.constant';

@Directive({
  selector: '[appCompanyName]'
})
export class CompanyNameDirective {
  constructor(private control: NgControl) {}

  @HostListener('input', ['$event']) onInput(e: KeyboardEvent): void {
    let value = (e.target as HTMLInputElement).value;
    value = value.replace(RegExps.COMPANY_NAME_CHARACTERS, '');
    this.control.control.setValue(value);
  }
}
